<h2 mat-dialog-title class="team-date-title" style="text-align: center">
  Termin
</h2>
<mat-dialog-content class="mat-typography">
  <div style="padding: 16px">
    <div class="row-layout" style="align-items: baseline">
      <div style="padding-top: 8px 8px 0 8px">
        <app-date-picker
          label="Datum"
          [value]="d"
          (valueChange)="onDateChange($event)"
          [required]="true"
        ></app-date-picker>
      </div>
      <div style="margin-left: 16px; padding: 0 8px">
        <app-time-picker
        label="Von:"
          [value]="startTime"
          (valueChange)="timeChangeHandler($event, true)"
          [required]="true"
        ></app-time-picker>
      </div>
      <div style="margin-left: 16px">
        <app-time-picker
        label="Bis:"
          [value]="endTime"
          (valueChange)="timeChangeHandler($event, false)"
          [required]="true"
        ></app-time-picker>
      </div>
    </div>
    <div *ngIf="order" style="margin: 1rem auto; width: fit-content">
      <div
        *ngIf="orderFixed"
        class="light-font-color"
        style="font-size: 1.2rem; margin-bottom: 0.5rem"
      >
        Aktueller Auftrag
      </div>
      <div *ngIf="!orderFixed" class="team-date-line">Auftrag-ID: {{ order.id }}</div>
      <div  class="team-date-line">
        {{ order.customer?.first_name }} {{ order.customer?.last_name }}
      </div>
      <ng-container *ngIf="order.montage_loctype === 0">
        <ng-container *ngIf="orderFixed">
          <div class="team-date-line mag-werkstatt-montage-location">Kundenwohnort</div>
        </ng-container>
        <ng-container *ngIf="!orderFixed">
          <div class="team-date-line">{{ order.customer?.address }}</div>
          <div class="team-date-line">{{ order.customer?.zip }} {{ order.customer?.city }}</div>
        </ng-container>
        <ng-container></ng-container>
      </ng-container>
      <div
        *ngIf="order.montage_loctype === 1"
        class="mag-werkstatt-montage-location"
      >
        MAG-Werkstatt
      </div>
      <ng-container *ngIf="order.montage_loctype === 2">
        <div class="team-date-line">{{ order.montage_address }}</div>
        <div class="team-date-line">
          {{ order.montage_zip ? order.montage_zip + " " : ""
          }}{{ order.montage_city }}
        </div>
      </ng-container>
      <div *ngIf="montageLocationUnknown" style="color: red">
        Montageort unbekannt
      </div>
      <ng-container *ngIf="!orderFixed">
        <div class="team-date-line">Tel: {{ order.customer?.phone }}<br /></div>
        <div class="team-date-line" *ngIf="order.customer?.mobile">Mobil: {{ order.customer?.mobile }}<br /></div>
      </ng-container>
      <div *ngIf="order.articlenr" style="margin-top: 16px;">
        Artikelnummer:<br>
        {{order.articlenr}}
      </div>
    </div>
    <div *ngIf="!order" style="margin-top: 16px">
      <div style="width: 100%" class="row-layout">
        <div style="width: 10rem">
          <mat-form-field style="width: 10rem" floatLabel="always">
            <mat-label>Status</mat-label>
            <mat-select [formControl]="statusFC">
              <mat-option *ngFor="let s of statuses" [value]="s">{{
                s.text
              }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div style="flex: 1; margin-left: 1rem">
          <app-input
            label="Suche in offenen Aufträgen"
            placeholder="ID, Team, Vor-/Nachname"
            [(value)]="searchValue"
          ></app-input>
        </div>
        <div style="margin-left: 1rem">
          <button
            mat-button
            (click)="search()"
            class="light-bg-color"
            style="height: 40px"
          >
            Offene Aufträge suchen
          </button>
        </div>
      </div>
      <div style="min-height: 100px; max-height: 400px">
        <div
          *ngIf="!searchPerformed"
          class="light-font-color"
          style="margin: 1rem auto; width: fit-content"
        >
          Keine Suche ausgeführt
        </div>
        <ng-container *ngIf="searchPerformed">
          <!--
            *ngIf="showGrid"
          -->
          <ag-grid-angular
            #grid
            style="height: 300px"
            [ngStyle]="{
              width: '100%'
            }"
            class="ag-theme-fresh"
            [rowData]="rowData"
            [gridOptions]="gridOptions"
            [overlayNoRowsTemplate]="noRowsTemplate"
          >
          </ag-grid-angular>
        </ng-container>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="row-layout" style="width: 100%; justify-content: space-between">
    <div>
      <button
        mat-button
        (click)="deleteDate()"
        [disabled]="!canDelete || orderFixed"
      >
        Löschen
      </button>
    </div>
    <div>
      <button mat-button (click)="close()">Abbrechen</button>
      <button mat-button (click)="save()" [disabled]="!canSave">
        Speichern
      </button>
    </div>
  </div>
</mat-dialog-actions>
